import { predicateFor } from './convertToKey';
import { keyInvalidMsg, keyRegexp } from './patterns';

export const isValidKey = predicateFor(
  (v: string) => !keyRegexp.test(v),
  () => keyInvalidMsg,
);
